export default __webpack_public_path__ + "static/media/we-wish-you.b2abdfba.webp";